import { useState } from 'react';
import PropTypes from 'prop-types';
import { Affix } from 'antd';
import Question from '../components/Question';
import Move from '../../../../components/forms/Move';
import { Element } from 'react-scroll';

export default function FormBreach({ dsBreachTemplate, isCheckQuetions }) {
    const [container, setContainer] = useState(null);

    return (
        <Element
            ref={setContainer}
            id="form-breach"
            className="bg-[#EDEEF9] w-full h-[80vh] p-8 overflow-auto flex justify-center"
        >
            <div className="m-auto flex justify-center relative gap-6">
                <Affix
                    target={() => container?.childBindings?.domNode}
                    offsetTop={20}
                >
                    <Question
                        dsBreachTemplate={dsBreachTemplate}
                        checkedError={isCheckQuetions}
                    />
                </Affix>
                <Move template={dsBreachTemplate} />
            </div>
        </Element>
    );
}

FormBreach.propTypes = {
    isCheckQuetions: PropTypes.bool,
    dsBreachTemplate: PropTypes.object,
};
